import {
  Flex,
  Text,
  Input,
  Button,
  Image,
  InputGroup,
  Spinner,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { goToDashboard } from "../../../routes/coordinator";
import { useNavigate, useParams } from "react-router-dom";
import imagem from "../../../assets/images/logo-big.png";
import Login from "../../../services/loginApi";
import { useRecoilState, useSetRecoilState } from "recoil";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { LoggedUser } from "../../../atoms/userLogged";
import axios from "axios";
import PermissionsAPI from "../../../services/permissionsAPI";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import { permissions } from "../../../atoms/permissions";
import { allPermissions } from "../../../atoms/allPermissions";
import moment from "moment";
import md5 from "md5";
import { openConfirmTerms } from "../../../atoms/openConfirmTerms";
import { useCookies } from "react-cookie";
import { customColors } from "../../../atoms/customColors";
import ClienteCoresLogoApi from "../../../services/clienteCoresLogoApi";
import { useMediaQuery } from "react-responsive";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import { WHITE } from "../../../constants/colors";
import ModalRequestNewPassword from "./modalRequestNewPassword";
import IpGetter from "../../../defaultFunctions/ipGetter";
import ModalSelectEmail from "./modalSelectEmail";
import ModalLoginPin from "./modalLoginPin";

import { atom } from "recoil";
import { apiResponseState } from "../../../atoms/loginState";

function LoginForm() {
  const initialValues = {
    pwd: "",
    email: "",
    secret: "",
  };
  const [apiResponse, setApiResponse] = useRecoilState(apiResponseState);

  const navigate = useNavigate();
  const { hash } = useParams();
  const hashString = hash;

  const isMobile = useMediaQuery({ query: "(max-width: 900px)" });

  const setOpen = useSetRecoilState(openConfirmTerms);
  const [cookies, setCookie, removeCookie] = useCookies();

  const colors = useRecoilState(customColors)[0];
  const setColors = useSetRecoilState(customColors);

  const [pin, setPin] = useState("");
  const [isOpenLoginPinModal, setIsOpenLoginPinModal] = useState(false);

  const handleClick = () => setShow(!show);

  useEffect(() => {
    if (hashString) {
      getCoresLogoClienteAntesdoLogin(hashString);
    }

    if (cookies.color) {
      setColors({
        ...colors,
        BLUEMONEDDBUTTONS: cookies.color.BLUEMONEDDBUTTONS
          ? cookies.color.BLUEMONEDDBUTTONS
          : colors.BLUEMONEDDBUTTONS,
        VARIANT: cookies.color.VARIANT ? cookies.color.VARIANT : colors.VARIANT,
      });
    }
  }, []);

  const [values, setValues] = React.useState(initialValues);
  const setUser = useSetRecoilState(LoggedUser);
  const user = useRecoilState(LoggedUser);
  const [show, setShow] = useState(false);
  const setPermissions = useSetRecoilState(permissions);
  const setSysPermissions = useSetRecoilState(allPermissions);
  const [loading, setLoading] = useState(false);

  const setRefresh = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  const image = imagem;

  async function getCoresLogoCliente(id: number) {
    try {
      const response = await ClienteCoresLogoApi.getCoresLogo(id);

      if (response.logo) {
        setCookie("logo", response.logo);

        setCookie("bg", response.background);

        setCookie("color", {
          BLUEMONEDDBUTTONS: response.primaria,
          VARIANT: response.secundaria,
        });

        setColors({
          ...colors,
          BLUEMONEDDBUTTONS: response.primaria
            ? response.primaria
            : colors.BLUEMONEDDBUTTONS,
          VARIANT: response.secundaria ? response.secundaria : colors.VARIANT,
        });
      } else if (
        (cookies.color || cookies.bg || cookies.logo) &&
        response.hash === null
      ) {
        removeCookie("color");
        removeCookie("logo");
        removeCookie("bg");
      }
      setRefresh(refresh + 1);
    } catch (error) {
      console.log(error);
    }
  }

  async function getCoresLogoClienteAntesdoLogin(hash: string) {
    try {
      const response = await ClienteCoresLogoApi.getCoresLogoAntesDeLogar(hash);

      if (response.hash) {
        setCookie("logo", response.logo);

        setCookie("bg", response.background);

        setCookie("color", {
          BLUEMONEDDBUTTONS: response.primaria,
          VARIANT: response.secundaria,
        });

        setColors({
          ...colors,
          BLUEMONEDDBUTTONS: response.primaria
            ? response.primaria
            : colors.BLUEMONEDDBUTTONS,
          VARIANT: response.secundaria ? response.secundaria : colors.VARIANT,
        });
      } else if (
        (cookies.color || cookies.bg || cookies.logo) &&
        response.hash === null
      ) {
        removeCookie("color");
        removeCookie("logo");
        removeCookie("bg");
      }
      setRefresh(refresh + 1);
    } catch (error) {
      console.log(error);
    }
  }

  const submitFirstLogin = async () => {
    try {
      setLoading(true);
      const obj = {
        pwd: values.pwd,
        email: values.email,
        secret: md5(`${values.email}-${moment().format("DD/MM/YYYY")}-cliente`),
      };

      const response: any = await Login.login2(obj);

      if (response.status >= 200 && response.status < 300) {
        setLoading(false);
        setIsOpenEmailModal(true);
      } else {
        setLoading(false);
        toast.error("Erro ao fazer login. Status: " + response.status);
      }
    } catch (error: any) {
      const errLg: any =
        error?.response?.data && typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Email ou senha inválidos, tente novamente.";
      toast.error(errLg);
      setLoading(false);
    }
  };

  const [codigo, setCodigo] = useState("");
  const submitLogin = async (pinCode: string) => {
    try {
      setLoading(true);
      const obj = {
        pwd: values.pwd,
        email: values.email,
        secret: md5(`${values.email}-${moment().format("DD/MM/YYYY")}-cliente`),
      };
      const response = await Login.login(obj, pinCode);

      if (response.statusCode !== 401) {
        console.log("Login API response:", response);
        setApiResponse(response);
        setCookie("auth", response.token, { path: "/" });
        console.log("Set auth cookie:", response.token); // Debug
        window.localStorage.setItem("token", response.token);
        setCookie("token", response.token, { path: "/" });
        window.localStorage.setItem("refreshToken", response.refreshToken);
        setCookie("refreshToken", response.refreshToken, { path: "/" });
        let jwtToken: JWTToken = jwt_decode(response.token || "");
        window.localStorage.setItem("user", JSON.stringify(response.user));
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.token}`;
        setUser({
          email: response.user.email,
          id: response.user.id,
          idEmpresa: response.user.idEmpresa,
          idLoginTipo: response.user.idLoginTipo,
          nome: response.user.nome,
        });
        await getPerms(Number(jwtToken.idCliente));
        setLoading(false);
        goToDashboard(navigate);
        getCoresLogoCliente(Number(jwtToken.idCliente));
      } else {
        setLoading(false);
        toast.error("PIN inválido.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Login error:", error);
      toast.error("PIN inválido");
    }
  };

  async function getPerms(id: number) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      const res = await PermissionsAPI.getSysPermissions(1, 100);
      setPermissions(response);
      // setSysPermissions(res);
    } catch (error) {
      console.log(error);
    }
  }

  const [isOpenPasswordModal, setIsOpenPasswordModal] = useState(false);
  const [isOpenEmailModal, setIsOpenEmailModal] = useState(false);

  return (
    <Flex
      w={"100%"}
      direction={"column"}
      px={"4"}
      justifyContent={"flex-start"}
    >
      <Flex
        justify={"center"}
        mt={cookies.logo ? "1vh" : isMobile ? "none" : "-10vh"}
        minH={cookies.logo ? "15vh" : "10vw"}
      >
        <Image
          src={
            cookies.logo && cookies.logo !== null
              ? cookies.logo
              : "/images/logoBranca.png"
          }
          style={{
            maxHeight: cookies.logo ? "120px" : "20vw",
            objectFit: "contain",
          }}
        />
      </Flex>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Flex
          width={"100%"}
          direction={"column"}
          mt={cookies.logo ? "none" : isMobile ? "none" : "-12vh"}
          h={"fit-content"}
        >
          <Input
            name="email"
            type={"text"}
            required
            bgColor={colors.WHITE}
            borderRadius={"15px"}
            my={2}
            h={"6vh"}
            placeholder="email@dominio.com.br"
            onChange={(e) => setValues({ ...values, email: e.target.value })}
          />
          <InputGroup size="md">
            <Input
              name="password"
              type={show ? "text" : "password"}
              required
              bgColor={colors.WHITE}
              borderRadius={"15px"}
              my={2}
              h={"6vh"}
              placeholder="Senha"
              onChange={(e) => setValues({ ...values, pwd: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  submitFirstLogin();
                }
              }}
            />
            <InputRightElement width="4.5rem">
              <IconButton
                mt={"4vh"}
                size="sm"
                onClick={handleClick}
                icon={show ? <ViewOffIcon /> : <ViewIcon />}
                aria-label="Show password"
              />
            </InputRightElement>
          </InputGroup>
          <Button
            color={colors.WHITE}
            type="button"
            w={"100%"}
            h={"6vh"}
            borderRadius={"15px"}
            onClick={submitFirstLogin}
            bgColor={!cookies.color ? "#09245B" : colors.BLUEMONEDDBUTTONS}
            mt={4}
            _hover={{ backgroundColor: colors.VARIANT }}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : <Text>Acessar</Text>}
          </Button>

          <Flex direction={"row"} py={"2"} justifyContent={"center"}>
            <Text fontSize={"1vw"} mr={"2"} color={WHITE}>
              Esqueceu sua senha?
            </Text>
            <Text
              fontSize={"1vw"}
              fontWeight={"bold"}
              color={WHITE}
              _hover={{ cursor: "pointer" }}
              onClick={() => setIsOpenPasswordModal(true)}
            >
              Clique aqui.
            </Text>
          </Flex>
        </Flex>
      </form>
      <ModalRequestNewPassword
        isOpen={isOpenPasswordModal}
        setIsOpen={setIsOpenPasswordModal}
      />
      <ModalSelectEmail
        isOpen={isOpenEmailModal}
        setIsOpen={setIsOpenEmailModal}
        email={values.email}
        submitLogin={submitLogin}
      />
    </Flex>
  );
}
export default LoginForm;
